import React, { Component } from "react";
import { Container, Row, Col, Alert } from "reactstrap";
import { ComisionesDeportivaAppGestionStore } from "../../containers/comisionesDeportivaAppGestion/ComisionesDeportivaAppGestion.store";
import { ComisionesDeportivaAppGestionDispatcher } from "../../containers/comisionesDeportivaAppGestion/ComisionesDeportivaAppGestion.dispatcher";
import { MemoTable } from "./ComisionesDeportivaAppGestion.table";
import DeportivaEventoAsignable from "../../../types/DeportivaEventoAsignable";
import {
  errorNotification,
  successNotification
} from "../../../utils/notifications";
import FormBuilderModal from "../common/formBuilderModal/formBuilderModal";
import FormBuilder from "../../../toolkit/baseForms2/formBuilder/FormBuilder";
import {
  Inputs,
  Buttons,
  formConfig
} from "./ComisionesDeportivaAppGestion.form";
import { formConfigInstructor } from "./ComisionesDeportivaAppGestionInstructor.form";
import { Archivo, RequestArchivo } from "../expedientsV2controls/types";

interface Props
  extends ComisionesDeportivaAppGestionDispatcher,
    ComisionesDeportivaAppGestionStore {}

interface State {
  idClub: number | null;
  rowPopup: DeportivaEventoAsignable;
  instructorPopupOpen: boolean;
}

export default class ComisionesDeportivaAppGestion extends Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      idClub: null,
      rowPopup: null,
      instructorPopupOpen: false
    };
  }

  handleSearch = async (values?: any) => {
    if (values) {
      this.setState({ idClub: values.idClub });
    }

    const preview = await this.props.getCmsEsperaDocumentacion({
      idClub: values ? values.idClub : this.state.idClub
    });

    if (!preview.fulfilled) {
      errorNotification("Error al cargar las ventas por gestionar");
    }
  };

  handleChangeInstructor = (row: DeportivaEventoAsignable) => {
    this.setState({
      rowPopup: row,
      instructorPopupOpen: true
    });
  };

  handleInstructorSubmit = async (values: any) => {
    const preview = await this.props.putCmsInstructorPrincipal(
      this.state.rowPopup.idProductoInstancia,
      {
        idEmpleado: values.idEmpleado,
        ignorarPuesto: values.ignorarPuesto === "true",
        razonIgnorarPuesto: values.razonIgnorarPuesto,
        fechaSugerida: values.fechaSugerida,
        horaSugerida: values.horaSugerida
      }
    );

    if (preview.fulfilled) {
      successNotification("Instructor actualizado correctamente");
      this.setState({ instructorPopupOpen: false, rowPopup: null });
      await this.handleSearch();
    } else {
      errorNotification(
        preview.puttingCmsInstructorPrincipalError ||
          "Error al actualizar el instructor"
      );
    }
  };

  handleVerificarDocumentacion = async (row: DeportivaEventoAsignable) => {
    const preview = await this.props.postCmsVerificarDocumentacion(
      row.idProductoInstancia
    );

    if (preview.fulfilled && preview) {
      successNotification("Documentación verificada correctamente");
      await this.handleSearch();
    } else {
      errorNotification(
        preview.postingCmsVerificarDocumentacionError ||
          "Error al verificar la documentación"
      );
    }
  };

  onRegenerar = async (
    row: DeportivaEventoAsignable,
    archivo: Archivo,
    values?: any
  ) => {
    if (values) {
      values = Object.keys(values).reduce((acc, key) => {
        acc[key] =
          values[key] !== null && values[key] !== undefined
            ? String(values[key])
            : values[key];
        return acc;
      }, {});
    }

    const requestArchivo: RequestArchivo = {
      codigo: archivo.codigo,
      idPersonaExpediente: row.idPersona,
      values
    };

    const preview = await this.props.putCmsArchivo(
      row.idProductoInstancia,
      requestArchivo
    );

    if (preview.fulfilled) {
      await this.handleSearch();
      successNotification("El documento se ha generado correctamente");
    } else {
      errorNotification(
        preview.puttingCmsArchivoError ||
          "Error al generar el documento, intente de nuevo por favor"
      );
    }
    return preview;
  };

  onCincelFirma = async (_row: DeportivaEventoAsignable, archivo: Archivo) => {
    const preview = await this.props.putCincelFirmas(
      archivo.idExpediente,
      archivo.idItem
    );

    if (preview.fulfilled) {
      await this.handleSearch();
      successNotification("El documento firmado se obtuvo correctamente");
      return preview;
    }

    errorNotification(
      preview.puttingCincelFirmasError || "Error al verificar las firmas"
    );
    return { fulfilled: false };
  };

  render() {
    const {
      cmsEsperaDocumentacion,
      gettingCmsEsperaDocumentacion,
      puttingCmsInstructorPrincipal,
      postingCmsVerificarDocumentacion,
      archivoRefreshLoading,
      cincelFirmasLoading
    } = this.props;
    const rowPopup = this.state.rowPopup || ({} as DeportivaEventoAsignable);
    const loading =
      gettingCmsEsperaDocumentacion ||
      puttingCmsInstructorPrincipal ||
      postingCmsVerificarDocumentacion ||
      archivoRefreshLoading ||
      cincelFirmasLoading;

    return (
      <Container>
        <FormBuilder<Inputs, Buttons>
          config={formConfig}
          submit={this.handleSearch}
          processing={loading}
        />

        <Row>
          <Col>
            <MemoTable
              data={cmsEsperaDocumentacion || []}
              loading={loading}
              onChangeInstructor={this.handleChangeInstructor}
              onVerificarDocumentacion={this.handleVerificarDocumentacion}
              onRegenerar={this.onRegenerar}
              onCincelFirma={this.onCincelFirma}
            />
          </Col>
        </Row>

        {/* Modal para cambiar instructor */}
        <FormBuilderModal
          message="Seleccione un instructor"
          isOpen={this.state.instructorPopupOpen}
          cancel={() =>
            this.setState({
              instructorPopupOpen: false,
              rowPopup: null
            })
          }
          title="Cambiar Instructor"
          formConfig={formConfigInstructor}
          ok={this.handleInstructorSubmit}
          values={{
            fechaSugerida: rowPopup.fechaSugerida,
            horaSugerida: rowPopup.horaSugerida
          }}
        >
          {!!rowPopup.fechaSugerida && (
            <Alert
              color="info"
              className="p-1 ml-3 mr-3 mt-2"
              data-form-name="titleSugerida"
            >
              El horario es informativo y fue seleccionado por el cliente. El
              cambio se reflejará solo en su cuenta.
            </Alert>
          )}
        </FormBuilderModal>
      </Container>
    );
  }
}
